import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { apiResponseFactory } from 'src/app/models/response/apiResponseFactory';
import { PagedResponse } from '../models/paged-response.model';
import { BaseApiService } from './base-api.service';
import { VarijabilneValuteDto } from '../models/varijabilne-valute.model';

@Injectable({
  providedIn: 'root'
})
export class VarijabilneValuteService {
  constructor(private api: BaseApiService) { }

  getAll(params: any = {}): Observable<VarijabilneValuteDto[]> {
    return this.api.get('varijabilne-valute/all', params).pipe(
      map((response: HttpResponse<apiResponseFactory>) => {
        if (response.status == 200 && response?.body?.result) {
          return response.body.result.map((client) => new VarijabilneValuteDto(client));
        }
        return undefined;
      }),
      catchError(this.handleError<VarijabilneValuteDto[]>(`getAllClients`))
    );
  }

  getPaged(params: any): Observable<PagedResponse<VarijabilneValuteDto>> {
    return this.api.post('varijabilne-valute', params).pipe(
      map((response) => {
        const pagedModel = new PagedResponse<VarijabilneValuteDto>(
          response.body.result
        );
        pagedModel.items = pagedModel.items?.map((i) => new VarijabilneValuteDto(i));
        return pagedModel;
      })
    );
  }

  getById(params: any): Observable<any> {
    return this.api
      .post('varijabilne-valute/by-id', params)
      .pipe(catchError(this.handleError<[]>(`varijabilne-valute/by-id`)));
  }

  getLastById(params: any): Observable<any> {
    return this.api
      .post('varijabilne-valute/last-by-id', params)
      .pipe(catchError(this.handleError<[]>(`varijabilne-valute/last-by-id`)));
  }

  update(params: any = {}): Observable<any> {
    return this.api
      .post('varijabilne-valute/update', params)
      .pipe(catchError(this.handleError<[]>('varijabilne-valute/update')));
  }

  create(params: any = {}): Observable<any> {
    return this.api
      .post('varijabilne-valute/create', params)
      .pipe(catchError(this.handleError<[]>('varijabilne-valute/create')));
  }

  delete(params: any): Observable<any> {
    return this.api
      .post('varijabilne-valute/delete', params)
      .pipe(catchError(this.handleError<[]>('varijabilne-valute/delete')));
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      const errorMsg = `${operation} failed: ${error.message}`;

      return throwError(error);
    };
  }
}
